import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Interface (lo que recibes del backend)
 */
export interface ConductorSiniestro {
  propietarioData: any;
  id?: number;
  id_siniestro?: number;
  nombre: string;
  tipodocumento: string;
  n_documento: number;
  rol_siniestro: number;
  fecha_nacimiento: string;
  estado_momento_siniestro: number;
  categoria: string;
  n_licencia: number;
  fecha_expedicion: string;
  fecha_vencimiento: string;
  usaba_cinturon: number;
  mision_laboral: number;
  estado?: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

@Injectable({
  providedIn: "root",
})
export class ConductoresSiniestrosVialesService {
  private apiUrl = `${environment.apiUrl}/api/conductores-siniestros-viales`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getConductores(): Observable<ConductorSiniestro[]> {
    return this.http
      .get<ConductorSiniestro[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Obtener por ID
  getConductorById(id: string | number): Observable<ConductorSiniestro> {
    return this.http
      .get<ConductorSiniestro>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getBySiniestroId(idSiniestro: string | number): Observable<ConductorSiniestro[]> {
    return this.http
      .get<ConductorSiniestro[]>(`${environment.apiUrl}/api/siniestro/${idSiniestro}/conductores-siniestros-viales`, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Crear
// Crear múltiples
createConductor(payload: ConductorSiniestro[]): Observable<ConductorSiniestro[]> {
  return this.http
    .post<ConductorSiniestro[]>(this.apiUrl, payload, { withCredentials: true })
    .pipe(catchError((error) => throwError(() => error)));
}


  // Actualizar
  updateConductor(id: string | number, payload: ConductorSiniestro): Observable<ConductorSiniestro> {
    return this.http
      .put<ConductorSiniestro>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Eliminar
  deleteConductor(id: string | number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Activar
  activar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Inactivar
  inactivar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}
